import { Users, Mail, ShieldCheck, Coins } from 'lucide-react';
import { Card, CardContent } from '@ncoder/ui';
import { useOrgMembers, useOrgRoles, useOrgInvitations, useOrgUsage } from '@/hooks/org-admin';
import { formatCurrencyUsd } from './usageFormat';

interface OverviewCardProps {
  label: string;
  value: string;
  icon: typeof Users;
  iconColor: string;
  valueColor: string;
}

function OverviewCard({ label, value, icon: Icon, iconColor, valueColor }: OverviewCardProps) {
  return (
    <Card className="relative">
      <CardContent className="p-4">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <p className="truncate text-xs font-medium text-muted-foreground">{label}</p>
            <Icon className={`h-4 w-4 ${iconColor}`} />
          </div>
          <p className={`text-xl font-bold ${valueColor}`}>{value}</p>
        </div>
      </CardContent>
    </Card>
  );
}

export function OrgAdminOverview() {
  const { data: members = [] } = useOrgMembers();
  const { data: roles = [] } = useOrgRoles();
  const { data: invitations = [] } = useOrgInvitations();
  const { data: usage } = useOrgUsage();

  const pendingCount = invitations.filter((invitation) => invitation.status === 'pending').length;

  return (
    <div className="grid shrink-0 grid-cols-2 gap-3 p-3 lg:grid-cols-4">
      <OverviewCard
        label="Members"
        value={String(members.length)}
        icon={Users}
        iconColor="text-primary"
        valueColor="text-primary"
      />
      <OverviewCard
        label="Pending invitations"
        value={String(pendingCount)}
        icon={Mail}
        iconColor="text-orange-500"
        valueColor="text-orange-500"
      />
      <OverviewCard
        label="Roles"
        value={String(roles.length)}
        icon={ShieldCheck}
        iconColor="text-accent"
        valueColor="text-accent"
      />
      <OverviewCard
        label="Org spend (cycle)"
        value={formatCurrencyUsd(usage?.total_spend_usd ?? 0)}
        icon={Coins}
        iconColor="text-emerald-500"
        valueColor="text-emerald-500"
      />
    </div>
  );
}
